import {
  selectAttachment,
  addDocument,
  removeDocument,
  updateCv,
  disableRequiredFields,
  initDatepicker,
  validations,
  parseCv,
  initFilepicker,
  successCvParser,
  errorCvParser,
  fileFromUrl,
} from '../../features/companies/candidates';

window.Bizneo.candidates_controller = {
  actions() {
    addDocument();
    disableRequiredFields();
    initDatepicker();
    removeDocument();
  },
  fileActions() {
    selectAttachment();
    updateCv();
  },
  new() {
    parseCv();
  },
  processedCv() {
    this.new();
    this.fileActions();
    initDatepicker();
  },
  validations() {
    validations();
  },
  async initFilepicker(file) {
    await initFilepicker(file);
  },
  async successCvParser(data) {
    const { data: fileData } = data;
    const file = await fileFromUrl(fileData);
    if (file) {
      successCvParser(data);
      window.Bizneo.location_suggester_controller.initialize_location_suggesters();
      window.Bizneo.jobs_suggester_controller.initialize_jobs_suggesters();
      window.Bizneo.controls.initializeTR();
      this.validations();
      await this.initFilepicker(file);
      this.processedCv();
      window.Bizneo.dom.update('.candidate-form-body');
    } else {
      this.errorCvParser();
    }
  },
  errorCvParser() {
    errorCvParser();
  },
};

jQuery(() => {
  if ($('.candidates-controller-js').length) {
    window.Bizneo.candidates_controller.actions();
    window.Bizneo.candidates_controller.fileActions();
    window.Bizneo.candidates_controller.validations();
  }

  if ($('.new-candidates-controller-js .cv-parser-container').length) {
    window.Bizneo.candidates_controller.new();
    window.Bizneo.candidates_controller.initFilepicker();
  }
});
